export enum enumStripePaymentState {
  SUCCEEDED = 'succeeded',
  PROCESSING = 'processing',
  REQUIRES_PAYMENT_METHOD = 'requires_payment_method',
}
